"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectUnselectItems = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var formstate_1 = require("formstate");
var styles_1 = require("./styles");
var Form_1 = require("../Form");
var SelectionList_1 = require("../SelectionList/SelectionList");
var lodash_1 = require("lodash");
var Tooltip = core_1.Tooltip;
var SelectUnselectItems = (function (_super) {
    __extends(SelectUnselectItems, _super);
    function SelectUnselectItems(props) {
        var _this = _super.call(this, props) || this;
        _this.selectItems = function () {
            var itemsAssigned = _this.state.itemsAssigned;
            var itemsUnassigned = _this.state.itemsUnassigned;
            itemsUnassigned = itemsUnassigned.filter(function (item) {
                if (item.active) {
                    item.active = false;
                    itemsAssigned.push(item);
                    return false;
                }
                return true;
            });
            _this.setState({ itemsAssigned: itemsAssigned, itemsUnassigned: itemsUnassigned, queryUnnassigned: '' });
            _this.form.$.unselected.onChange('');
            _this.onReturnAssignedUnassignedItems({ itemsAssigned: itemsAssigned, itemsUnassigned: itemsUnassigned });
        };
        _this.unselectItems = function () {
            var itemsUnassigned = _this.state.itemsUnassigned;
            var itemsAssigned = _this.state.itemsAssigned;
            itemsAssigned = itemsAssigned.filter(function (item) {
                if (item.active) {
                    item.active = false;
                    itemsUnassigned.push(item);
                    return false;
                }
                return true;
            });
            _this.setState({ itemsAssigned: itemsAssigned, itemsUnassigned: itemsUnassigned, queryAssigned: '' });
            _this.form.$.selected.onChange('');
            _this.onReturnAssignedUnassignedItems({ itemsAssigned: itemsAssigned, itemsUnassigned: itemsUnassigned });
        };
        _this.selectItemFromUnselectedList = function (element, evt) {
            var _a = _this.state, itemsUnassigned = _a.itemsUnassigned, lastSelectedUnnasigned = _a.lastSelectedUnnasigned, queryUnnassigned = _a.queryUnnassigned;
            var newList = handleListSelection(element, itemsUnassigned, lastSelectedUnnasigned, evt, queryUnnassigned);
            _this.setState({
                itemsUnassigned: newList,
                lastSelectedUnnasigned: evt.shiftKey ? lastSelectedUnnasigned : element
            });
        };
        _this.selectItemFromSelectedList = function (element, evt) {
            var _a = _this.state, itemsAssigned = _a.itemsAssigned, lastSelectedAssigned = _a.lastSelectedAssigned, queryAssigned = _a.queryAssigned;
            var newList = handleListSelection(element, itemsAssigned, lastSelectedAssigned, evt, queryAssigned);
            _this.setState({
                itemsAssigned: newList,
                lastSelectedAssigned: evt.shiftKey ? lastSelectedAssigned : element
            });
        };
        _this.selectAll = function () {
            var _a = _this.state, itemsAssigned = _a.itemsAssigned, itemsUnassigned = _a.itemsUnassigned;
            var newItemsUnnasigned = [];
            var newItemsAssigned = itemsAssigned.map(function (item) { return (__assign(__assign({}, item), { active: false })); });
            itemsUnassigned = itemsUnassigned.map(function (item) { return (__assign(__assign({}, item), { active: false })); });
            itemsUnassigned.forEach(function (item) {
                if (!_this.state.queryUnnassigned ||
                    item.text
                        .toUpperCase()
                        .includes(_this.state.queryUnnassigned.toUpperCase())) {
                    newItemsAssigned.push(__assign(__assign({}, item), { active: false }));
                }
                else {
                    newItemsUnnasigned.push(item);
                }
            });
            _this.setState({
                itemsAssigned: newItemsAssigned,
                itemsUnassigned: newItemsUnnasigned,
                queryUnnassigned: ''
            });
            _this.form.$.unselected.onChange('');
            _this.onReturnAssignedUnassignedItems({
                itemsAssigned: newItemsAssigned,
                itemsUnassigned: newItemsUnnasigned
            });
        };
        _this.unselectAll = function () {
            var _a = _this.state, itemsAssigned = _a.itemsAssigned, itemsUnassigned = _a.itemsUnassigned;
            var newItemsAssigned = [];
            var newItemsUnnasigned = itemsUnassigned.map(function (item) { return (__assign(__assign({}, item), { active: false })); });
            itemsAssigned.map(function (item) { return (__assign(__assign({}, item), { active: false })); });
            itemsAssigned.forEach(function (item) {
                if (!_this.state.queryAssigned ||
                    item.text.toUpperCase().includes(_this.state.queryAssigned.toUpperCase())) {
                    newItemsUnnasigned.push(__assign(__assign({}, item), { active: false }));
                }
                else {
                    newItemsAssigned.push(item);
                }
            });
            _this.setState({
                itemsAssigned: newItemsAssigned,
                itemsUnassigned: newItemsUnnasigned,
                queryAssigned: ''
            });
            _this.form.$.selected.onChange('');
            _this.onReturnAssignedUnassignedItems({
                itemsAssigned: newItemsAssigned,
                itemsUnassigned: newItemsUnnasigned
            });
        };
        _this.onReturnAssignedUnassignedItems = function (obj) { var _a, _b; return (_b = (_a = _this.props).onReturnAssignedUnassignedItems) === null || _b === void 0 ? void 0 : _b.call(_a, obj); };
        _this.handleSave = function () {
            var _a, _b;
            var _c = _this.state, itemsUnassigned = _c.itemsUnassigned, itemsAssigned = _c.itemsAssigned;
            (_b = (_a = _this.props).handleSave) === null || _b === void 0 ? void 0 : _b.call(_a, { itemsUnassigned: itemsUnassigned, itemsAssigned: itemsAssigned });
        };
        _this.handleCancel = function () {
            var _a, _b;
            (_b = (_a = _this.props).handleCancel) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        _this.getAssignedItems = function (elements) {
            return _this.props.enableSelectedOrdering
                ? (0, SelectionList_1.getElementsEnumerated)(elements)
                : elements;
        };
        _this.reorderSelectedItems = function (direction) {
            if (_this.state.itemsAssigned.filter(function (item) { return item.active; }).length === 1) {
                var itemsAssigned = (0, lodash_1.cloneDeep)(_this.state.itemsAssigned);
                var itemIndex_1 = -1;
                var item = _this.state.itemsAssigned.find(function (item, index) {
                    if (item.active) {
                        itemIndex_1 = index;
                    }
                    return item.active;
                });
                if (item && itemIndex_1 !== -1) {
                    if (direction === 'UP' && itemIndex_1 > 0) {
                        var otherItem = itemsAssigned[itemIndex_1 - 1];
                        itemsAssigned[itemIndex_1 - 1] = item;
                        itemsAssigned[itemIndex_1] = otherItem;
                    }
                    else if (direction === 'DOWN' &&
                        itemIndex_1 < itemsAssigned.length - 1) {
                        var otherItem = itemsAssigned[itemIndex_1 + 1];
                        itemsAssigned[itemIndex_1 + 1] = item;
                        itemsAssigned[itemIndex_1] = otherItem;
                    }
                    _this.setState({ itemsAssigned: itemsAssigned });
                }
            }
        };
        _this.disableReorderButtons = function (direction) {
            if (_this.state.itemsAssigned.filter(function (item) { return item.active; }).length !== 1) {
                return true;
            }
            var itemIndex = -1;
            _this.state.itemsAssigned.some(function (item, index) {
                if (item.active) {
                    itemIndex = index;
                }
                return item.active;
            });
            return ((direction === 'UP' && itemIndex === 0) ||
                (direction === 'DOWN' &&
                    itemIndex === _this.state.itemsAssigned.length - 1));
        };
        _this.form = new formstate_1.FormState({
            unselected: new formstate_1.FieldState(''),
            selected: new formstate_1.FieldState('')
        });
        _this.state = {
            itemsUnassigned: [],
            itemsAssigned: [],
            lastSelectedAssigned: null,
            lastSelectedUnnasigned: null
        };
        _this.setState = _this.setState.bind(_this);
        return _this;
    }
    SelectUnselectItems.prototype.componentDidMount = function () {
        var _a = this.props, itemsAssigned = _a.itemsAssigned, itemsUnassigned = _a.itemsUnassigned;
        this.setState({ itemsAssigned: itemsAssigned, itemsUnassigned: itemsUnassigned });
    };
    SelectUnselectItems.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.itemsUnassigned !== prevProps.itemsUnassigned) {
            this.setState({
                itemsAssigned: this.props.ignoreFilterForItemsAssigned
                    ? this.props.itemsAssigned
                    : [],
                itemsUnassigned: this.props.itemsUnassigned
            });
        }
    };
    SelectUnselectItems.prototype.render = function () {
        var _this = this;
        var _a = this.props, intentSave = _a.intentSave, intentCancel = _a.intentCancel, displayCount = _a.displayCount, getTemplate = _a.getTemplate;
        var _b = this.state, itemsUnassigned = _b.itemsUnassigned, itemsAssigned = _b.itemsAssigned;
        var itemsUnassignedSearch = itemsUnassigned.map(function (item) { return ({
            label: item.text,
            value: item.value
        }); });
        var itemsAssignedSearch = itemsAssigned.map(function (item) { return ({
            label: item.text,
            value: item.value
        }); });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.BodyContainer, null,
                react_1.default.createElement(styles_1.FlexCol, { flex: 4 },
                    react_1.default.createElement("h4", null, "".concat(this.props.unAssignedText ||
                        'UnAssigned', " ").concat((displayCount &&
                        "(".concat((itemsUnassigned && itemsUnassigned.length) || 0, ")")) ||
                        '')),
                    react_1.default.createElement(styles_1.StyledScroll, { height: this.props.listsHeights || '242.5px', style: {
                            height: this.props.listsHeights || '242.5px',
                            marginBottom: '6px'
                        } },
                        react_1.default.createElement(styles_1.VSelectionListStyled, __assign({ selection: this.props.selection, elements: itemsUnassigned.filter(function (item) {
                                return !_this.state.queryUnnassigned ||
                                    item.text
                                        .toUpperCase()
                                        .includes(_this.state.queryUnnassigned.toUpperCase());
                            }), onSelect: this.selectItemFromUnselectedList, height: this.props.listsHeights || '242.5px' }, { getTemplate: getTemplate }))),
                    react_1.default.createElement("div", { style: { width: 'calc(100% + 3px)', marginBottom: '5px' } },
                        react_1.default.createElement(Form_1.VInputFieldWithSuggestions, { fill: true, noLabel: true, minimal: true, placeholder: 'Search...', margin: '10px 0 10px', options: itemsUnassignedSearch, id: 'unselected', fieldState: this.form.$.unselected, upperCaseFormat: true, autoComplete: 'no', onChange: function (value) {
                                onAutoComplete(value, _this.state, _this.setState, 'queryUnnassigned', 'itemsUnassigned');
                            }, layer: {
                                inputWidth: 12
                            } }))),
                react_1.default.createElement(styles_1.CentralFlexCol, { flex: 1 },
                    react_1.default.createElement(Tooltip, { usePortal: true, hoverCloseDelay: 0, content: 'Select', openOnTargetFocus: false },
                        react_1.default.createElement(core_1.Button, { large: true, minimal: true, icon: 'chevron-right', onClick: this.selectItems })),
                    react_1.default.createElement(Tooltip, { usePortal: true, hoverCloseDelay: 0, content: 'Unselect', openOnTargetFocus: false },
                        react_1.default.createElement(core_1.Button, { large: true, minimal: true, icon: 'chevron-left', onClick: this.unselectItems })),
                    react_1.default.createElement(Tooltip, { usePortal: true, hoverCloseDelay: 0, content: 'Select All', openOnTargetFocus: false },
                        react_1.default.createElement(core_1.Button, { large: true, minimal: true, icon: 'double-chevron-right', onClick: this.selectAll })),
                    react_1.default.createElement(Tooltip, { usePortal: true, hoverCloseDelay: 0, content: 'Unselect All', openOnTargetFocus: false },
                        react_1.default.createElement(core_1.Button, { large: true, minimal: true, icon: 'double-chevron-left', onClick: this.unselectAll })),
                    this.props.enableSelectedOrdering && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ButtonWithTooltipAllowingDisable, { disabled: this.disableReorderButtons('UP'), onClick: function () {
                                _this.reorderSelectedItems('UP');
                            }, icon: 'chevron-up', text: 'Move Item up' }),
                        react_1.default.createElement(ButtonWithTooltipAllowingDisable, { disabled: this.disableReorderButtons('DOWN'), onClick: function () {
                                _this.reorderSelectedItems('DOWN');
                            }, icon: 'chevron-down', text: 'Move Item Down' })))),
                react_1.default.createElement(styles_1.FlexCol, { flex: 4 },
                    react_1.default.createElement("h4", null, "".concat(this.props.assignedText || 'Assigned', " ").concat((displayCount &&
                        "(".concat((itemsAssigned && itemsAssigned.length) || 0, ")")) ||
                        '')),
                    react_1.default.createElement(styles_1.StyledScroll, { height: this.props.listsHeights || '242.5px', style: {
                            height: this.props.listsHeights || '242.5px',
                            marginBottom: '6px'
                        } },
                        react_1.default.createElement(styles_1.VSelectionListStyled, __assign({ selection: this.props.selection, elements: this.getAssignedItems(itemsAssigned).filter(function (item) {
                                return !_this.state.queryAssigned ||
                                    item.text
                                        .toUpperCase()
                                        .includes(_this.state.queryAssigned.toUpperCase());
                            }), onSelect: this.selectItemFromSelectedList, height: this.props.listsHeights || '242.5px' }, { getTemplate: getTemplate }))),
                    react_1.default.createElement("div", { style: { width: 'calc(100% + 3px)', marginBottom: '5px' } },
                        react_1.default.createElement(Form_1.VInputFieldWithSuggestions, { fill: true, minimal: true, noLabel: true, margin: '10px 0 10px', placeholder: 'Search...', options: itemsAssignedSearch, id: 'selected', upperCaseFormat: true, fieldState: this.form.$.selected, autoComplete: 'no', onChange: function (value) {
                                onAutoComplete(value, _this.state, _this.setState, 'queryAssigned', 'itemsAssigned');
                            }, layer: {
                                inputWidth: 12
                            } })))),
            this.props.handleSave && (react_1.default.createElement(styles_1.ButtonsEndsContainers, null,
                react_1.default.createElement(core_1.Button, { minimal: true, intent: intentSave ? intentSave : 'success', icon: 'tick', text: 'Save', onClick: this.handleSave }),
                react_1.default.createElement(core_1.Button, { minimal: true, intent: intentCancel ? intentCancel : 'danger', icon: 'disable', onClick: this.handleCancel, text: 'Cancel' })))));
    };
    return SelectUnselectItems;
}(react_1.Component));
exports.SelectUnselectItems = SelectUnselectItems;
var onAutoComplete = function (value, state, setState, stateKey, stateList) {
    var _a;
    if (value !== state[stateKey]) {
        var newList = (0, lodash_1.cloneDeep)(state[stateList] || []);
        newList.forEach(function (item) {
            if (value && !item.text.toUpperCase().includes(value.toUpperCase())) {
                item.active = false;
            }
        });
        setState(__assign(__assign({}, state), (_a = {}, _a[stateKey] = value, _a[stateList] = newList, _a)));
    }
};
var ButtonWithTooltipAllowingDisable = function (_a) {
    var disabled = _a.disabled, onClick = _a.onClick, icon = _a.icon, text = _a.text;
    return disabled ? (react_1.default.createElement(core_1.Button, { large: true, minimal: true, icon: icon, onClick: onClick, disabled: disabled })) : (react_1.default.createElement(Tooltip, { usePortal: true, hoverCloseDelay: 0, content: text, openOnTargetFocus: false },
        react_1.default.createElement(core_1.Button, { large: true, minimal: true, icon: icon, onClick: onClick, disabled: disabled })));
};
var handleListSelection = function (element, argList, lastSelected, evt, query) {
    if (query === void 0) { query = ''; }
    var newList = (0, lodash_1.cloneDeep)(argList);
    if (!(evt.ctrlKey || evt.shiftKey)) {
        newList = newList.map(function (item) { return (__assign(__assign({}, item), { active: false })); });
        newList.some(function (stateItem, index) {
            var result = element.value === stateItem.value;
            if (result) {
                newList[index].active = true;
            }
            return result;
        });
    }
    else if (evt.ctrlKey) {
        newList.some(function (stateItem, index) {
            var result = element.value === stateItem.value;
            if (result) {
                newList[index].active = !!element.active;
            }
            return result;
        });
    }
    else if (evt.shiftKey) {
        newList = newList.map(function (item) { return (__assign(__assign({}, item), { active: false })); });
        var lastSelectedIndex_1 = 0;
        var clickedElementIndex_1 = -1;
        newList.forEach(function (stateItem, index) {
            if (lastSelected && stateItem.value === lastSelected.value) {
                lastSelectedIndex_1 = index;
            }
            if (element && stateItem.value === element.value) {
                clickedElementIndex_1 = index;
            }
        });
        var start_1 = lastSelectedIndex_1 > clickedElementIndex_1
            ? lastSelectedIndex_1
            : clickedElementIndex_1;
        var end_1 = lastSelectedIndex_1 > clickedElementIndex_1
            ? clickedElementIndex_1
            : lastSelectedIndex_1;
        newList.forEach(function (stateItem, index) {
            if (start_1 >= index &&
                index >= end_1 &&
                (!query ||
                    newList[index].text.toUpperCase().includes(query.toUpperCase()))) {
                newList[index].active = true;
            }
        });
    }
    return newList;
};
